<template>
  <div class="container-box">
    <h2 class="title-type-1">
      Kakao VX Partners
      <v-tooltip right content-class="tooltip-custom-1">
        <template v-slot:activator="{ on, attrs }">
          <v-icon class="ico-help-1" v-bind="attrs" v-on="on">mdi-help</v-icon>
        </template>
        <span
          >카카오 VX 캠페인을 진행한 모든 광고주, 대행사, 카카오그룹 관리 메뉴
          입니다</span
        >
      </v-tooltip>
    </h2>

    <!-- search-box-1 -->
    <div class="search-box-1 mb-n3">
      <div class="search">
        <div class="sel" style="width: 144px">
          <v-select
            :items="searchSel"
            :label="searchSel[0]"
            v-model="searchSelChoice"
            item-color="#000"
            class="input-custom-1"
            height="40px"
            solo
            @change="searchType"
          ></v-select>
        </div>
      </div>
      <div class="btn">
        <v-btn
          large
          depressed
          max-height="40px"
          color="#fecd06"
          class="button-type-1"
          @click.prevent="$router.push({ name: 'partnerRegister' })"
        >
          <v-icon left> mdi-plus </v-icon>
          광고주 등록
        </v-btn>
      </div>
    </div>
    <!-- //search-box-1 -->
    <p class="text-total-1 mb-3">
      총 <strong>{{ totalList }}</strong
      >건 입니다.
    </p>
    <div class="table-wrap relative">
      <v-data-table
        :headers="boardHeaders"
        :items="customBoardLists"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        class="board-list-1"
        hide-default-footer
        @page-count="pageCount = $event"
        :search="searchText"
      >
        <template v-slot:top>
          <div
            class="input"
            style="position: absolute; left: 152px; top: -84px"
          >
            <v-text-field
              label="광고주 / 대행사 / 그룹사명"
              class="input-custom-1"
              height="40px"
              solo
              v-model="searchText"
              append-icon="mdi-magnify"
              single-line
              hide-details
            ></v-text-field>
          </div>
        </template>
        <template v-slot:body="{ items, headers }">
          <tbody v-if="items.length > 0">
            <tr v-for="(item, index) in items" :key="index">
              <td>
                {{ item.no }}
              </td>
              <td>
                {{ item.typeKor }}
              </td>
              <td>
                <router-link :to="`/partners/modify/${item.id}`">
                  {{ item.name }}
                </router-link>
              </td>
              <td>
                {{ item.sector.name || `-` }}
              </td>
              <td>
                <span v-if="!!item.manager_name">
                  {{ item.manager_name }}
                </span>
                <span v-else> - </span>
              </td>
              <td>
                {{ item.email || `-` }}
              </td>
              <td>
                {{ item.campaign_cnt }}
              </td>
              <td>
                {{ item.create_at | moment('YYYY.MM.DD') }}
              </td>
              <td>
                {{ item.creator.manager_name || `-` }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td :colspan="headers.length" style="text-align: center">
                검색결과가 없습니다.
              </td>
            </tr>
          </tbody>
        </template>
        <template v-slot:no-data>
          <div class="text-center">목록이 없습니다.</div>
        </template>
      </v-data-table>
    </div>
    <div class="pagination-1">
      <div class="sel-sort">
        <span>페이지당 행개수</span>
        <v-select
          :items="pageSel"
          :label="pageSel[0]"
          v-model="pageSelChoice"
          item-color="#000"
          class="input-custom-1"
          height="40px"
          solo
          @change="itemsPerPage = parseInt($event, 10)"
        ></v-select>
      </div>

      <v-btn
        icon
        :plain="true"
        :ripple="false"
        :disabled="page == 1"
        @click="page = 1"
      >
        <v-icon>mdi-page-first</v-icon>
      </v-btn>

      <v-pagination
        v-model="page"
        :length="pageCount"
        total-visible="10"
        color="transparent"
      ></v-pagination>

      <v-btn
        icon
        :plain="true"
        :ripple="false"
        :disabled="page == pageCount"
        @click="page = pageCount"
      >
        <v-icon>mdi-page-last</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { advertiserList } from '@/api/advertiser';
import { constantAdvertiserType } from '@/utils/constant';

import bus from '@/utils/bus';
export default {
  data: () => ({
    searchText: '',
    searchSel: ['전체', '광고주', '대행사', '내부광고'],
    searchSelChoice: '전체',
    pageSel: ['10', '25', '50', '100'],
    pageSelChoice: '10',
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    boardHeaders: [
      {
        text: 'No',
        value: 'no',
        width: '8%',
        sortable: false,
        filterable: false,
      },
      {
        text: '분류',
        value: 'type',
        width: '10%',
        sortable: false,
        filterable: false,
      },
      {
        text: '회사명',
        value: 'name',
        width: '12%',
        sortable: false,
      },
      {
        text: '업종',
        value: 'sector',
        width: '12%',
        sortable: false,
        filterable: false,
      },
      {
        text: '담당자 성명',
        value: 'manager_name',
        width: '10%',
        sortable: false,
        filterable: false,
      },
      { text: '대표 메일', value: 'email', sortable: false, filterable: false },
      {
        text: '캠페인수',
        value: 'campaign_cnt',
        width: '9%',
        sortable: false,
        filterable: false,
      },
      {
        text: '등록일',
        value: 'create_at',
        width: '10%',
        sortable: false,
        filterable: false,
      },
      {
        text: '등록 관리자',
        value: 'creator',
        width: '11%',
        sortable: false,
        filterable: false,
      },
    ],
    boardLists: [],
    originList: [],
  }),
  computed: {
    totalList() {
      let result = 0;
      if (this.boardLists.length > 0) {
        result = this.boardLists.length;
      }
      return result;
    },
    customBoardLists() {
      for (let num = 0; num < this.boardLists.length; num++) {
        let item = this.boardLists[num];
        item.no = this.boardLists.length - num;
        //type을 광고주, 대행사, 내부광고 바꿈.
        item.typeKor = constantAdvertiserType[item.type];
      }
      return this.boardLists;
    },
  },
  methods: {
    async fetchList() {
      try {
        const { data } = await advertiserList();
        this.boardLists = data.list;
        this.originList = data.list;
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },
    searchType() {
      if (this.searchSelChoice === '전체') {
        this.boardLists = this.originList;
      } else if (this.searchSelChoice === '광고주') {
        let arr = [];
        this.originList.forEach(item => {
          if (item.type === 'advertiser') {
            arr.push(item);
          }
        });
        this.boardLists = arr;
      } else if (this.searchSelChoice === '대행사') {
        let arr = [];
        this.originList.forEach(item => {
          if (item.type === 'agency') {
            arr.push(item);
          }
        });
        this.boardLists = arr;
      } else {
        let arr = [];
        this.originList.forEach(item => {
          if (item.type === 'internal') {
            arr.push(item);
          }
        });
        this.boardLists = arr;
      }
    },
  },
  created() {
    bus.$emit('start:spinner');
    this.fetchList();
  },
};
</script>

<style></style>
